import { render, staticRenderFns } from "./ShipmentInvoice.vue?vue&type=template&id=14fe958b&scoped=true&"
import script from "./ShipmentInvoice.vue?vue&type=script&lang=js&"
export * from "./ShipmentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentInvoice.vue?vue&type=style&index=0&id=14fe958b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fe958b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fe958b')) {
      api.createRecord('14fe958b', component.options)
    } else {
      api.reload('14fe958b', component.options)
    }
    module.hot.accept("./ShipmentInvoice.vue?vue&type=template&id=14fe958b&scoped=true&", function () {
      api.rerender('14fe958b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ShipmentInvoice.vue"
export default component.exports